<div class="card">
  <app-header titulo="Pesagem - Balança" descricao="Gerencie as pesagens de remessas com a balança."></app-header>

  <div class="flex flex-wrap align-items-center justify-content-between gap-3 mb-2">
    <!-- Legenda das cores da coluna Tipo -->
    <div class="flex align-items-center gap-3">
      <div class="flex align-items-center gap-1" *ngFor="let item of legendaTipoRemessa">
        <span [ngClass]="item.cor" style="width: 10px; height: 10px; display: inline-block;"></span>
        <span class="text-xs text-500">{{ item.label }}</span>
      </div>
    </div>
    <div class="flex justify-content-end flex-wrap gap-3" *ngIf="instanciaSelecionada">
      <div class="flex align-items-center gap-1" *ngIf="totalInconsistente > 0">
        <span class="border-circle bg-red-500" style="width: 8px; height: 8px; display: inline-block;"></span>
        <span class="text-xs text-500">Inconsistente:</span>
        <span class="text-xs text-500">{{ totalInconsistente }}</span>
      </div>
      <div class="flex align-items-center gap-1" *ngIf="totalLiberado > 0">
        <span class="border-circle bg-blue-500" style="width: 8px; height: 8px; display: inline-block;"></span>
        <span class="text-xs text-500">Liberado:</span>
        <span class="text-xs text-500">{{ totalLiberado }}</span>
      </div>
      <div class="flex align-items-center gap-1" *ngIf="totalEmAndamento > 0">
        <span class="border-circle bg-yellow-500" style="width: 8px; height: 8px; display: inline-block;"></span>
        <span class="text-xs text-500">Em andamento:</span>
        <span class="text-xs text-500">{{ totalEmAndamento }}</span>
      </div>
      <div class="flex align-items-center gap-1" *ngIf="totalFinalizado > 0">
        <span class="border-circle bg-green-500" style="width: 8px; height: 8px; display: inline-block;"></span>
        <span class="text-xs text-500">Finalizado:</span>
        <span class="text-xs text-500">{{ totalFinalizado }}</span>
      </div>
    </div>
  </div>

  <p-table #dt [value]="capturas" [lazy]="true" (onLazyLoad)="carregar($event)" [totalRecords]="totalRecords" [loading]="loading" dataKey="id" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20,50,100]" [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" sortField="remessa" [sortOrder]="-1">
    <ng-template pTemplate="caption">
      <div class="flex flex-wrap align-items-center justify-content-between gap-2">
        <div class="flex flex-wrap align-items-center gap-2">
          <span class="text-500 text-xs">Instância:</span>
          <app-empresa-dropdown modo="unico" [(selecionadas)]="instanciaSelecionada" (funcaoChange)="onInstanciaChange()" styleClass="text-xs"></app-empresa-dropdown>
        </div>
        <div class="flex flex-wrap align-items-center gap-2">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" style="font-size: 0.8rem; padding: 0.4rem 0.5rem 0.4rem 2rem; min-width: 20rem;" [(ngModel)]="busca" (input)="onBuscaChange()" placeholder="Buscar por remessa, placa ou status..." pTooltip="Pesquise pelo número da remessa, placa do veículo ou status (ex.: PC ou Pesagem Concluída)" tooltipPosition="top" />
          </span>
          <p-button icon="pi pi-filter-slash" [rounded]="true" [text]="true" severity="secondary" (onClick)="limparFiltros()" *ngIf="busca || statusRemessaSelecionados.length || produtosSelecionados.length" pTooltip="Limpar filtros" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-file-excel" severity="success" [outlined]="true" size="small" (onClick)="exportar()" [loading]="loadingExportar" pTooltip="Exportar" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" (onClick)="recarregar()" [loading]="loading" pTooltip="Atualizar" tooltipPosition="top"></p-button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 16px; min-width: 16px; max-width: 16px; padding: 0;"></th>
        <th pSortableColumn="remessa" style="min-width: 110px;">Remessa <p-sortIcon field="remessa"></p-sortIcon></th>
        <th pSortableColumn="descricaoProduto" style="min-width: 160px;">Produto <p-sortIcon field="descricaoProduto"></p-sortIcon>
          <p-columnFilter field="descricaoProduto" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <p-multiSelect [ngModel]="produtosSelecionados" [options]="opcoesProduto" optionValue="value" optionLabel="label" placeholder="Todos" selectedItemsLabel="{0} selecionados" [filter]="true" (onChange)="onProdutoChange($event.value, filter)">
                <ng-template let-option pTemplate="item">
                  <span class="text-sm">{{ option.label }}</span>
                </ng-template>
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="clearfiltericon"></ng-template>
          </p-columnFilter>
        </th>
        <th style="min-width: 85px; width: 85px;">Placa</th>
        <th style="min-width: 80px;"><span>Peso<br>Entrada</span></th>
        <th pSortableColumn="dtPeso1" style="min-width: 120px;">Data Entrada <p-sortIcon field="dtPeso1"></p-sortIcon></th>
        <th style="min-width: 80px;"><span>Peso<br>Saída</span></th>
        <th pSortableColumn="dtPeso2" style="min-width: 120px;">Data Saída <p-sortIcon field="dtPeso2"></p-sortIcon></th>
        <th style="min-width: 80px;"><span>Peso<br>Líquido</span></th>
        <th pSortableColumn="statusRemessa" style="min-width: 130px;">Status <p-sortIcon field="statusRemessa"></p-sortIcon>
          <p-columnFilter field="statusRemessa" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <p-multiSelect [ngModel]="statusRemessaSelecionados" [options]="opcoesStatusRemessa" optionValue="value" optionLabel="label" placeholder="Todos" selectedItemsLabel="{0} selecionados" [filter]="false" (onChange)="onStatusRemessaChange($event.value, filter)">
                <ng-template let-option pTemplate="item">
                  <span class="text-sm">{{ option.label }}</span>
                </ng-template>
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="clearfiltericon"></ng-template>
          </p-columnFilter>
        </th>
        <th style="min-width: 140px;">Mensagem</th>
        <th style="min-width: 140px;">Ação Recomendada</th>
        <th pFrozenColumn alignFrozen="right" style="min-width: 80px; text-align: center;">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-captura>
      <tr [ngClass]="'small'">
        <td [ngClass]="corTipoRemessa(captura.tipoRemessa)" style="width: 16px; min-width: 16px; max-width: 16px; padding: 0;" [pTooltip]="labelTipoRemessa(captura.tipoRemessa)" tooltipPosition="top"></td>
        <td class="font-bold">{{ captura.remessa }}</td>
        <td>{{ captura.descricaoProduto }}</td>
        <td>{{ captura.placaVeiculo }}</td>
        <td>
          <span *ngIf="captura.peso1 != null">{{ captura.peso1 | number:'1.0-0' }} kg</span>
        </td>
        <td>{{ captura.dtPeso1 | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <span *ngIf="captura.peso2 != null">{{ captura.peso2 | number:'1.0-0' }} kg</span>
        </td>
        <td>{{ captura.dtPeso2 | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <span *ngIf="captura.pesoLiquido != null">{{ captura.pesoLiquido | number:'1.0-0' }} kg</span>
        </td>
        <td><app-tag-status [status]="captura.statusRemessa"></app-tag-status></td>
        <td>
          <span *ngIf="captura.deMensagemInteg" style="word-break: break-word;">{{ captura.deMensagemInteg }}</span>
        </td>
        <td>
          <span *ngIf="captura.acaoRecomendada" style="word-break: break-word;">{{ captura.acaoRecomendada }}</span>
        </td>
        <td pFrozenColumn alignFrozen="right" style="text-align: center;">
          <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info" (onClick)="abrirDetalhes(captura)" pTooltip="Ver detalhes" tooltipPosition="top"></p-button>
          <p-button icon="pi pi-bolt" [rounded]="true" [text]="true" severity="success" (onClick)="abrirPesar(captura)" pTooltip="Realizar pesagem" tooltipPosition="top" [disabled]="!podeRealizar(captura)"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="13">
          <div class="flex flex-column align-items-center justify-content-center py-5">
            <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
            <span class="text-500 font-medium">Nenhuma remessa encontrada.</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- DIALOG: PESAGEM -->
<p-dialog header="Realizar Pesagem" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '480px' }" [closable]="true">
  <div class="flex flex-column gap-2 mt-1">
    <div *ngIf="loadingDadosPesagem" class="flex align-items-center gap-2 text-500 mb-1">
      <i class="pi pi-spin pi-spinner text-sm"></i>
      <span class="text-sm">Carregando dados...</span>
    </div>
    <ng-container *ngIf="!loadingDadosPesagem && dadosPesagem">
      <div class="surface-ground border-round p-2">
        <div class="grid">
          <div class="col-6">
            <span class="text-500 text-sm block mb-1">Remessa</span>
            <span class="text-700 text-xs">{{ dadosPesagem.remessa }}</span>
          </div>
          <div class="col-6">
            <span class="text-500 text-sm block mb-1">Produto</span>
            <span class="text-700 text-xs">{{ dadosPesagem.produto }}</span>
          </div>
          <div class="col-6">
            <span class="text-500 text-sm block mb-1">Cliente</span>
            <span class="text-700 text-xs">{{ dadosPesagem.cliente }}</span>
          </div>
          <div class="col-6">
            <span class="text-500 text-sm block mb-1">Etapa</span>
            <span class="text-700 text-xs">{{ dadosPesagem.etapa }}</span>
          </div>
        </div>
      </div>

      <div class="grid p-fluid">
        <div class="col-12 field mb-0">
          <label class="font-medium text-800 text-sm">
            Peso Capturado <span class="text-red-500" *ngIf="pesoCapturado == null">*</span>
          </label>
          <p-inputNumber [(ngModel)]="pesoCapturado" [minFractionDigits]="0" [maxFractionDigits]="0" [useGrouping]="false" placeholder="0" suffix=" kg" [disabled]="!podeEditarPesoManual" [pTooltip]="!podeEditarPesoManual ? 'Edição manual não permitida. Use o botão Capturar da Balança.' : ''" tooltipPosition="top"></p-inputNumber>
        </div>
        <div class="col-12 field">
          <p-button [label]="tipoProdutoCapturado ? 'Capturar Peso do ' + tipoProdutoCapturado : 'Capturar da Balança'" icon="pi pi-wifi" severity="info" [outlined]="true" (onClick)="capturarDaBalanca()" [loading]="loadingCapturar" styleClass="w-full text-sm"></p-button>
        </div>
      </div>

      <div *ngIf="loadingVerificarAnalise || loadingVerificarLacre" class="flex align-items-center gap-2 text-500">
        <i class="pi pi-spin pi-spinner text-xs"></i>
        <span class="text-xs">Verificando parâmetros...</span>
      </div>

      <!-- Lacre: sempre visível na pesagem de saída (peso1 já preenchido) -->
      <ng-container *ngIf="lacreVisivel && !loadingVerificarLacre">
        <div class="mb-2">
          <div class="flex align-items-center justify-content-between mb-1">
            <label class="font-medium text-800 text-sm">Lacres</label>
            <p-tag [value]="lacreObrigatorio ? 'Obrigatório' : 'Opcional'" [severity]="lacreObrigatorio ? 'danger' : 'secondary'" [rounded]="true" styleClass="text-xs"></p-tag>
          </div>
          <div class="flex align-items-center gap-2 mb-1">
            <input pInputText type="text" [(ngModel)]="lacreInput" placeholder="Número do lacre" class="flex-grow-1 text-sm" (keydown.enter)="adicionarLacre()" />
            <p-button icon="pi pi-plus" severity="info" [rounded]="true" (onClick)="adicionarLacre()" pTooltip="Adicionar lacre" tooltipPosition="top" [disabled]="!lacreInput.trim()"></p-button>
          </div>
          <div *ngIf="lacres.length > 0" class="flex flex-wrap gap-2">
            <p-tag *ngFor="let lacre of lacres; let i = index" severity="info" [rounded]="true" styleClass="text-xs">
              <span>{{ lacre }}</span>
              <i class="pi pi-times ml-2 cursor-pointer" style="font-size: 0.7rem;" (click)="removerLacre(i)"></i>
            </p-tag>
          </div>
          <span *ngIf="lacres.length === 0" class="text-400 text-xs">Nenhum lacre adicionado.</span>
        </div>
      </ng-container>

      <!-- Análises: apenas quando análise for permitida -->
      <ng-container *ngIf="precisaAnalise && !loadingVerificarAnalise">
        <div *ngIf="tiposAnalise.length > 0">
          <div class="flex align-items-center justify-content-between mb-1">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-chart-bar text-primary text-xs"></i>
              <span class="font-medium text-800 text-sm">Análises</span>
            </div>
            <p-tag value="Obrigatório" severity="danger" [rounded]="true" styleClass="text-xs"></p-tag>
          </div>
          <div class="grid p-fluid">
            <div class="col-12 md:col-6 field" *ngFor="let analise of analises; let i = index">
              <label class="font-medium text-800 text-xs">{{ getDescricaoAnalise(analise.codigo_analise) }}</label>
              <p-inputNumber [(ngModel)]="analises[i].valor_analise" [minFractionDigits]="2" [maxFractionDigits]="4" placeholder="Valor"></p-inputNumber>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" size="small" (onClick)="displayDialog = false"></p-button>
      <p-button label="Confirmar Pesagem" icon="pi pi-check" size="small" (onClick)="confirmarSalvar()" [loading]="loadingSalvar" [disabled]="pesoCapturado == null"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- DIALOG: DETALHES -->
<p-dialog header="Detalhes da Remessa" [(visible)]="displayDetalhesDialog" [modal]="true" [style]="{ width: '720px' }" [closable]="true">

  <!-- SEÇÃO: Identificação -->
  <div class="mb-2">
    <div class="flex align-items-center gap-2 mb-1">
      <i class="pi pi-file text-primary text-sm"></i>
      <span class="font-medium text-700 text-sm">Identificação</span>
    </div>
    <div class="surface-ground border-round p-2">
      <div class="grid">
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Remessa</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.remessa }}</span>
        </div>
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Data Remessa</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.dataRemessa | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Empresa / Filial</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.empresa }} / {{ detalhesSelecionado.filial }}</span>
        </div>
        <div class="col-8 mt-2">
          <span class="text-500 text-sm block mb-1">Cliente</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.descricaoCliente }}</span>
        </div>
        <div class="col-3 mt-2">
          <span class="text-500 text-sm block mb-1">Cód. Produto</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.codigoProduto }}</span>
        </div>
        <div class="col-9 mt-2">
          <span class="text-500 text-sm block mb-1">Produto</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.descricaoProduto }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SEÇÃO: Veículo e Motorista -->
  <div class="mb-2">
    <div class="flex align-items-center gap-2 mb-1">
      <i class="pi pi-truck text-primary text-sm"></i>
      <span class="font-medium text-700 text-sm">Veículo e Motorista</span>
    </div>
    <div class="surface-ground border-round p-2">
      <div class="grid">
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Placa</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.placaVeiculo }}</span>
        </div>
        <div class="col-8">
          <span class="text-500 text-sm block mb-1">Transportadora</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.descricaoTransportadora }}</span>
        </div>
        <div class="col-12 mt-2">
          <span class="text-500 text-sm block mb-1">Motorista</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.descricaoMotorista }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SEÇÃO: Pesagem -->
  <div class="mb-2">
    <div class="flex align-items-center gap-2 mb-1">
      <i class="pi pi-calculator text-primary text-sm"></i>
      <span class="font-medium text-700 text-sm">Pesagem</span>
    </div>
    <div class="surface-ground border-round p-2">
      <div class="grid">
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Peso Entrada</span>
          <span *ngIf="detalhesSelecionado.peso1 != null" class="text-700 text-xs">{{ detalhesSelecionado.peso1 | number:'1.0-0' }} kg</span>
        </div>
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Data/Hora Peso Entrada</span>
          <span *ngIf="detalhesSelecionado.dtPeso1 != null" class="text-700 text-xs">{{ detalhesSelecionado.dtPeso1 | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="col-4">
          <span class="text-500 text-sm block mb-1">Peso Líquido</span>
          <span *ngIf="detalhesSelecionado.pesoLiquido != null" class="text-primary text-xs">{{ detalhesSelecionado.pesoLiquido | number:'1.0-0' }} kg</span>
        </div>
        <div class="col-4 mt-2">
          <span class="text-500 text-sm block mb-1">Peso Saída</span>
          <span *ngIf="detalhesSelecionado.peso2 != null" class="text-700 text-xs">{{ detalhesSelecionado.peso2 | number:'1.0-0' }} kg</span>
        </div>
        <div class="col-4 mt-2">
          <span class="text-500 text-sm block mb-1">Data/Hora Peso Saída</span>
          <span *ngIf="detalhesSelecionado.dtPeso2 != null" class="text-700 text-xs">{{ detalhesSelecionado.dtPeso2 | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="col-12 mt-2" *ngIf="detalhesSelecionado.lacre">
          <span class="text-500 text-sm block mb-1">Lacres</span>
          <div class="flex flex-wrap gap-2">
            <p-tag *ngFor="let l of detalhesSelecionado.lacre.split(';')" [value]="l" severity="info" [rounded]="true" styleClass="text-xs"></p-tag>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SEÇÃO: Status -->
  <div class="mb-2">
    <div class="flex align-items-center gap-2 mb-1">
      <i class="pi pi-chart-bar text-primary text-sm"></i>
      <span class="font-medium text-700 text-sm">Status</span>
    </div>
    <div class="surface-ground border-round p-2">
      <div class="grid">
        <div class="col-6">
          <span class="text-500 text-sm block mb-1">Remessa</span>
          <app-tag-status [status]="detalhesSelecionado.statusRemessa"></app-tag-status>
        </div>
        <div class="col-6">
          <span class="text-500 text-sm block mb-1">Integração</span>
          <app-tag-status [status]="detalhesSelecionado.fgStatusInteg"></app-tag-status>
        </div>
        <div class="col-12 mt-2" *ngIf="detalhesSelecionado.dataConclusao">
          <span class="text-500 text-sm block mb-1">Concluído em</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.dataConclusao | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="col-12 mt-2" *ngIf="detalhesSelecionado.deMensagemInteg">
          <span class="text-500 text-sm block mb-1">Mensagem</span>
          <span class="text-700 text-xs">{{ detalhesSelecionado.deMensagemInteg }}</span>
        </div>
        <div class="col-12 mt-2" *ngIf="detalhesSelecionado.acaoRecomendada">
          <span class="text-500 text-sm block mb-1">Ação Recomendada</span>
          <div class="flex align-items-start gap-2 border-round p-2 mt-1" style="background: var(--yellow-50); border: 1px solid var(--yellow-300);">
            <i class="pi pi-exclamation-triangle text-yellow-600 flex-shrink-0" style="margin-top: 2px;"></i>
            <span class="text-yellow-800 text-xs">{{ detalhesSelecionado.acaoRecomendada }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SEÇÃO: Análises (só exibe se houver análises) -->
  <div *ngIf="detalhesSelecionado.analises && detalhesSelecionado.analises.length > 0">
    <div class="flex align-items-center gap-2 mb-1">
      <i class="pi pi-list text-primary text-sm"></i>
      <span class="font-medium text-700 text-sm">Análises</span>
    </div>
    <p-table [value]="detalhesSelecionado.analises" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 160px;">Código</th>
          <th style="min-width: 120px; text-align: right;">Valor</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-analise>
        <tr>
          <td>
            <span class="text-700 text-xs">{{ getDescricaoAnalise(analise.codigoAnalise) }}</span>
            <span class="text-400 text-xs ml-2">({{ analise.codigoAnalise }})</span>
          </td>
          <td style="text-align: right;">
            <span *ngIf="analise.valorAnalise != null" class="text-700 text-xs">{{ analise.valorAnalise | number:'1.2-4' }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Fechar" icon="pi pi-times" severity="secondary" [outlined]="true" size="small" (onClick)="displayDetalhesDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-confirmDialog styleClass="border-round-xl"></p-confirmDialog>
